// extracted by css-extract-rspack-plugin
export default {"container":"interactive-tile-area-module__container___lWHPf"};